// this is dynamic because it is changed when apple@carvia.de signs in for app approval
// see LoginView.vue
export const API_URL = {
  value:
    import.meta.env.VITE_BACKEND_URL === ':4000'
      ? 'http://' + window.location.hostname + ':4000'
      : import.meta.env.VITE_BACKEND_URL,
};
